export default __webpack_public_path__ + "static/media/008-snorkeling.5f5c96cd.svg";